module.exports = __webpack_public_path__ + "static/img/aktivasyon_gonderildi.292bb38.png";